import axios from 'axios';
import cookie from 'react-cookies';
import { API_URL } from '../constants';

const baseApi = process.env.REACT_APP_API_URL || API_URL;

function headers(useToken) {
  let options = {};

  if (useToken) {
    const token = cookie.load('token');
    options = {
      Authorization: 'Token ' + token,
    };
  }

  return options;
}

export function get(url, useToken = true) {
  return axios({
    method: 'GET',
    url: baseApi + url,
    headers: headers(useToken),
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response && err.response.data) {
        return { error: err.response.data };
      } else {
        return null;
      }
    });
}

export function post(url, data, useToken = true) {
  return axios({
    method: 'POST',
    url: baseApi + url,
    data,
    headers: headers(useToken),
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response && err.response.data) {
        return { error: err.response.data };
      } else {
        return null;
      }
    });
}

export function patch(url, data, useToken = true) {
  return axios({
    method: 'PATCH',
    url: baseApi + url,
    data,
    headers: headers(useToken),
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response && err.response.data) {
        return { error: err.response.data };
      } else {
        return null;
      }
    });
}

export function del(url, useToken = true) {
  return axios({
    method: 'DELETE',
    url: baseApi + url,
    headers: headers(useToken),
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response && err.response.data) {
        return { error: err.response.data };
      } else {
        return null;
      }
    });
}



// WEBPACK FOOTER //
// src/services/request.js